import { Grid } from "@material-ui/core";
import React from "react";
import { Text, Input, Button, SelectBox } from "sunrise-ui";
import "./Users.scss";
import { regEmail, regPan, regIFSC } from "../../utilities/regx";
//---for api-------------
import { useDispatch, useSelector } from "react-redux";
import {
  postAddUserData,
  getAllUserData,
  putUserData,
  subContractorTypeData,
} from "../../redux/reducers/users";
import { AppDispatch } from "../../redux/store";
import { uiSliceActions } from "../../redux/reducers/uiState";
import ImageInputComponent from "../../utilities/ImageInputComponent";
import Loader from "../../utilities/Loader";

//---validator function of reducer-------
const validaiator = (state: any, action: any) => {
  switch (action.type) {
    case "firmName":
      return { ...state, firmName: action.payload, firmNameErr: false };
    case "firmNameErr":
      return { ...state, firmNameErr: action.payload };
    case "ownerName":
      return { ...state, ownerName: action.payload, ownerNameErr: false };
    case "ownerNameErr":
      return { ...state, ownerNameErr: action.payload };
    case "address":
      return { ...state, address: action.payload, addressErr: false };
    case "addressErr":
      return { ...state, addressErr: action.payload };
    case "subContractorType":
      return {
        ...state,
        subContractorType: action.payload,
        subContractorTypeErr: false,
      };
    case "subContractorTypeErr":
      return { ...state, subContractorTypeErr: action.payload };

    case "phoneNumber":
      return {
        ...state,
        phoneNumber: action.payload,
        phoneNumberErr: false,
      };
    case "phoneNumberErr":
      return { ...state, phoneNumberErr: action.payload };
    case "alternateNumber":
      return {
        ...state,
        alternateNumber: action.payload,
        alternateNumberErr: false,
      };
    case "alternateNumberErr":
      return {
        ...state,
        alternateNumberErr: action.payload,
      };
    case "email":
      return { ...state, email: action.payload, emailErr: false };
    case "emailErr":
      return { ...state, emailErr: action.payload };

    case "aadhaarNumber":
      return {
        ...state,
        aadhaarNumber: action.payload,
        aadhaarNumberErr: false,
      };
    case "aadhaarNumberErr":
      return {
        ...state,
        aadhaarNumberErr: action.payload,
      };
    case "panNumber":
      return { ...state, panNumber: action.payload, panNumberErr: false };
    case "panNumberErr":
      return { ...state, panNumberErr: action.payload };
    case "bankName":
      return { ...state, bankName: action.payload, bankNameErr: false };
    case "bankNameErr":
      return { ...state, bankNameErr: action.payload };
    case "bankAccountNumber":
      return {
        ...state,
        bankAccountNumber: action.payload,
        bankAccountNumberErr: false,
      };
    case "bankAccountNumberErr":
      return {
        ...state,
        bankAccountNumberErr: action.payload,
      };
    case "accountOwnerName":
      return {
        ...state,
        accountOwnerName: action.payload,
        accountOwnerNameErr: false,
      };
    case "accountOwnerNameErr":
      return {
        ...state,
        accountOwnerNameErr: action.payload,
      };
    case "IFSC":
      return { ...state, IFSC: action.payload, ifscErr: false };
    case "ifscErr":
      return { ...state, ifscErr: action.payload };
    case "reset":
      return { ...initialFormState };
    default:
      return { ...state, gstNumber: action.payload };
  }
};
//---------intial state of form-------
const initialFormState = {
  firmName: "",
  firmNameErr: false,
  ownerName: "",
  ownerNameErr: false,
  address: "",
  addressErr: false,
  subContractorType: "",
  subContractorTypeErr: false,
  phoneNumber: "",
  phoneNumberErr: false,
  alternateNumber: "",
  alternateNumberErr: false,
  email: "",
  emailErr: false,
  panNumber: "",
  panNumberErr: false,
  aadhaarNumber: "",
  aadhaarNumberErr: false,
  gstNumber: "",
  bankAccountNumber: "",
  bankAccountNumberErr: false,
  bankName: "",
  bankNameErr: false,
  accountOwnerName: "",
  accountOwnerNameErr: false,
  IFSC: "",
  ifscErr: false,
};

const AddSubContractor = () => {
  const dispatch = useDispatch<AppDispatch>();
  // -----------loader state------------
  let [loading, setLoading] = React.useState(false);
  // --------------------------------
  const addUserData = useSelector((state: any) => state.USERS.addUserData);
  const editUserData = useSelector((state: any) => state.USERS.editUserData);
  const editData = useSelector(
    (state: any) => state.SPECIFICPROJECT.userEditData
  );
  // ---------useReducer for valodation of form and manage state---------------
  const [state, dispatchState] = React.useReducer(
    validaiator,
    initialFormState
  );
  //--to get sub contractor types---
  React.useEffect(() => {
    dispatch(
      subContractorTypeData({
        endPoint: "master-data/get-master-data?type=sub-contractor",
      })
    );
  }, [dispatch]);
  const subContractorTypes = useSelector(
    (state: any) => state.USERS.subContractorType
  );
  const changeResetSubContractorType = () => { };

  // -----------for passbook image upload--------
  const [passbookImg, setPassbookImg] = React.useState<File | null>();
  const [passbookImgName, setPassbookImgName] = React.useState("");
  const [passbookImgErr, setPassbookImgErr] = React.useState(false);

  // ----------for aadhaar img upload-------------
  const [aadhaarImg, setAadhaarImg] = React.useState<File | null>();
  const [aadhaarImgName, setAadhaarImgName] = React.useState("");
  const [aadhaarImgErr, setAadhaarImgErr] = React.useState(false);

  // ----------for PAN img upload-------------
  const [panImg, setPanImg] = React.useState<File | null>();
  const [panImgName, setPanImgName] = React.useState("");
  const [panImgErr, setPanImgErr] = React.useState(false);

  // ----------for Candidate img upload-------------
  const [GSTImg, setGSTImg] = React.useState<File | null>();
  const [GSTImgName, setGSTImgName] = React.useState("");

  //-----------handle Submit-------------
  const handleSubmit = () => {
    if (loading === false) {
      let goodToGo = true;
      for (const [key, value] of Object.entries(state)) {
        if (
          key !== "alternateNumber" &&
          key !== "email" &&
          key !== "gstNumber" &&
          value === ""
        ) {
          dispatchState({ type: `${key}Err`, payload: true });
          goodToGo = false;
        }
      }
      if (state?.phoneNumber?.length !== 10) {
        dispatchState({ type: "phoneNumberErr", payload: true });
        goodToGo = false;
      }
      if (
        state?.alternateNumber?.length !== 10 &&
        state?.alternateNumber?.length !== 0
      ) {
        dispatchState({ type: "alternateNumberErr", payload: true });
        goodToGo = false;
      }
      if (state?.panNumber?.length !== 10 || !regPan.test(state?.panNumber)) {
        dispatchState({ type: "panNumberErr", payload: true });
        goodToGo = false;
      }
      if (state?.aadhaarNumber?.length !== 12) {
        dispatchState({ type: "aadhaarNumberErr", payload: true });
        goodToGo = false;
      }
      if (state?.IFSC?.length !== 11 || !regIFSC.test(state.IFSC)) {
        dispatchState({ type: "ifscErr", payload: true });
        goodToGo = false;
      }
      if (state?.email !== "") {
        if (!regEmail.test(state?.email)) {
          dispatchState({ type: "emailErr", payload: true });
          goodToGo = false;
        }
      }
      if (aadhaarImg === null || aadhaarImg === undefined) {
        setAadhaarImgErr(true);
        goodToGo = false;
      }
      if (panImg === null || panImg === undefined) {
        setPanImgErr(true);
        goodToGo = false;
      }
      if (passbookImg === null || passbookImg === undefined) {
        setPassbookImgErr(true);
        goodToGo = false;
      }
      if (goodToGo === true) {
        // --------call API-------
        let imgUri = `${process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_URL
          : process.env.REACT_APP_PRO_URL
          }/images/`;
        let myObj = {
          address: state?.address,
          isPermanent: false,
          mobileNumber: {
            primaryNumber: state?.phoneNumber,
            secondaryNumber: state?.alternateNumber,
          },
          role: "sub-contractor",
          emailId: state?.email,

          aadhar: {
            number: state?.aadhaarNumber,
            image:
              aadhaarImgName?.indexOf(imgUri) > -1
                ? aadhaarImgName
                : `${imgUri}${aadhaarImgName}`,
          },
          isSubContractor: true,
          subContractor: {
            type: state?.subContractorType,
            companyName: state?.firmName,
            ownerName: state?.ownerName.trim(),
            gstNumber: state?.gstNumber,
            gstCertificateImage:
              GSTImgName?.indexOf(imgUri) > -1
                ? GSTImgName
                : `${imgUri}${GSTImgName}`,
          },
          pan: {
            number: state?.panNumber,
            image:
              panImgName?.indexOf(imgUri) > -1
                ? panImgName
                : `${imgUri}${panImgName}`,
          },
          bankDetails: {
            name: state?.bankName,
            account: state?.bankAccountNumber,
            accountOwnerName: state?.accountOwnerName,
            ifsc: state?.IFSC,
            image:
              passbookImgName?.indexOf(imgUri) > -1
                ? passbookImgName
                : `${imgUri}${passbookImgName}`,
          },
          dateHistory: {
            intitalDateTime: new Date().toISOString(),
            updatedDateTime: new Date().toISOString(),
          },
        };
        const cleanObject = (obj: any) => {
          Object.keys(obj).forEach(
            (key) =>
              // eslint-disable-next-line no-mixed-operators
              (obj[key] &&
                typeof obj[key] === "object" &&
                cleanObject(obj[key])) ||
              // eslint-disable-next-line no-mixed-operators
              ((obj[key] === undefined ||
                obj[key] === null ||
                obj[key] === "") &&
                delete obj[key])
          );
          return obj;
        };

        let objCleaned = cleanObject(myObj);
        if (
          editData?.type === "edit" &&
          editData?.userDetail?.role?.toLowerCase().replace("-", " ") ===
          "sub contractor"
        ) {
          setLoading(true);
          dispatch(
            putUserData({
              endPoint: `admin/update-user/${editData?.userID}/update/subcontractor`,
              data: objCleaned,
            })
          ).then((res) => {
            setLoading(false);
          });
        } else {
          setLoading(true);
          dispatch(
            postAddUserData({ endPoint: "admin/add-user", data: objCleaned })
          ).then((res) => {
            setLoading(false);
          });
        }
      }
    }
  };
  //---if user added success clear the form---
  React.useEffect(() => {
    if (addUserData?.status || editUserData?.status) {
      dispatch(getAllUserData({ endPoint: "admin/get-user" }));
      handleCancel();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addUserData, editUserData, dispatch]);
  //   -----------handle cancel---------
  const handleCancel = () => {
    dispatchState({ type: "reset", payload: "" });
    setGSTImg(null);
    setGSTImgName("");
    setAadhaarImgErr(false);
    setAadhaarImg(null);
    setAadhaarImgName("");
    setPanImgErr(false);
    setPanImg(null);
    setPanImgName("");
    setPassbookImgErr(false);
    setPassbookImg(null);
    setPassbookImgName("");
    dispatch(uiSliceActions.setUserInitialState());
  };
  //----for edit user fill the fields with old data------
  React.useEffect(() => {
    if (
      editData?.type === "edit" &&
      editData?.userDetail?.role?.toLowerCase().replace("-", " ") ===
      "sub contractor"
    ) {
      dispatchState({
        type: "firmName",
        payload: editData?.userDetail?.subContractor?.companyName,
      });
      dispatchState({
        type: "ownerName",
        payload: editData?.userDetail?.subContractor?.ownerName,
      });
      dispatchState({
        type: "address",
        payload: editData?.userDetail?.address,
      });
      dispatchState({
        type: "subContractorType",
        payload: editData?.userDetail?.subContractor?.type,
      });
      dispatchState({
        type: "phoneNumber",
        payload: editData?.userDetail?.mobileNumber?.primaryNumber?.toString(),
      });
      dispatchState({
        type: "alternateNumber",
        payload:
          editData?.userDetail?.mobileNumber?.secondaryNumber?.toString() || "",
      });

      dispatchState({
        type: "email",
        payload: editData?.userDetail?.emailId,
      });

      dispatchState({
        type: "aadhaarNumber",
        payload: editData?.userDetail?.aadhar?.number?.toString(),
      });
      dispatchState({
        type: "panNumber",
        payload: editData?.userDetail?.pan?.number,
      });
      dispatchState({
        type: "bankName",
        payload: editData?.userDetail?.bankDetails?.name,
      });
      dispatchState({
        type: "bankAccountNumber",
        payload: editData?.userDetail?.bankDetails?.account,
      });
      dispatchState({
        type: "accountOwnerName",
        payload: editData?.userDetail?.bankDetails?.accountOwnerName,
      });
      dispatchState({
        type: "gstNumber",
        payload: editData?.userDetail?.subContractor?.gstNumber,
      });

      dispatchState({
        type: "IFSC",
        payload: editData?.userDetail?.bankDetails?.ifsc,
      });
    }
    setPassbookImgErr(false);
    setPassbookImg(editData?.userDetail?.bankDetails?.image);
    setPassbookImgName(editData?.userDetail?.bankDetails?.image);
    setAadhaarImgErr(false);
    setAadhaarImg(editData?.userDetail?.aadhar?.image);
    setAadhaarImgName(editData?.userDetail?.aadhar?.image);
    setPanImgErr(false);
    setPanImg(editData?.userDetail?.pan?.image);
    setPanImgName(editData?.userDetail?.pan?.image);
    setGSTImg(editData?.userDetail?.subContractor?.gstCertificateImage);
    setGSTImgName(editData?.userDetail?.subContractor?.gstCertificateImage);
  }, [editData]);

  //method to capitalize the first letter
  const Capitalize = (str: any) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  return (
    <Grid container spacing={2} className="first_tab_content">
      {/* -------Owner/Representative Name input field------ */}
      <Grid item xs={4}>
        <Text type="normal" fonts="normal" fontSize={16} className="mb mt0">
          <span className="fw500">Representative Name*</span>
        </Text>
        <Input
          color={state?.ownerNameErr ? "danger" : "primary"}
          fonts="normal"
          placeholder="Enter Here"
          required
          value={state?.ownerName}
          maxLength={30}
          type="text"
          onChange={(e) => {
            dispatchState({ type: "ownerName", payload: e.target.value });
          }}
        />
        <Text
          type={state?.ownerNameErr ? "danger" : "normal"}
          fonts="normal"
          fontSize={12}
          className={state?.ownerNameErr ? "mb0 mt0 float-right" : "d-none"}
        >
          Please Enter Representative Name
        </Text>
      </Grid>
      {/* -------Sub Contractor Firm/Company Name input field------ */}
      <Grid item xs={4}>
        <Text type="normal" fonts="normal" fontSize={16} className="mb mt0">
          <span className="fw500">Sub-Contractor Company Name*</span>
        </Text>
        <Input
          color={state?.firmNameErr ? "danger" : "primary"}
          fonts="normal"
          placeholder="Enter Here"
          required
          value={state?.firmName}
          maxLength={30}
          type="text"
          onChange={(e) => {
            dispatchState({ type: "firmName", payload: e.target.value });
          }}
        />
        <Text
          type={state?.firmNameErr ? "danger" : "normal"}
          fonts="normal"
          fontSize={12}
          className={state?.firmNameErr ? "mb0 mt0 float-right" : "d-none"}
        >
          Please Enter Sub-Contractor Company Name
        </Text>
      </Grid>
      {/* -------Address input field------ */}
      <Grid item xs={4}>
        <Text type="normal" fonts="normal" fontSize={16} className="mb mt0">
          <span className="fw500">Address*</span>
        </Text>
        <Input
          color={state?.addressErr ? "danger" : "primary"}
          fonts="normal"
          placeholder="Enter Here"
          required
          value={state?.address}
          maxLength={40}
          type="text"
          onChange={(e) => {
            dispatchState({ type: "address", payload: e.target.value });
          }}
        />
        <Text
          type={state?.addressErr ? "danger" : "normal"}
          fonts="normal"
          fontSize={12}
          className={state?.addressErr ? "mb0 mt0 float-right" : "d-none"}
        >
          Please Enter Address
        </Text>
      </Grid>
      {/* -------Type of Sub-contractor input field------ */}
      <Grid item xs={4}>
        <Text type="normal" fonts="normal" fontSize={16} className="mb0 mt1">
          <span className="fw500">Type of Sub-contractor*</span>
        </Text>

        <SelectBox
          data={
            Array.isArray(subContractorTypes)
              ? subContractorTypes.map((subContractorType: String) =>
                Capitalize(subContractorType)
              )
              : []
          }
          placeHolder="Select Sub-Contractor Type"
          defaultVal={state?.subContractorType}
          onChange={(e) => {
            let target = { ...e };
            dispatchState({
              type: "subContractorType",
              payload: target.target.value,
            });
          }}
          resetVal={state?.subContractorType === "" ? true : false}
          changeReset={changeResetSubContractorType}
          borderColor={state?.subContractorTypeErr ? "danger" : "primary"}
        />
        <Text
          type={state?.subContractorTypeErr ? "danger" : "normal"}
          fonts="normal"
          fontSize={12}
          className={
            state?.subContractorTypeErr ? "mb0 mt0 float-right" : "d-none"
          }
        >
          Please Select Sub-Contractor Type
        </Text>
      </Grid>
      {/* -------primary phone number input field------ */}
      <Grid item xs={4}>
        <Text type="normal" fonts="normal" fontSize={16} className="mb mt1">
          <span className="fw500">Phone Number*</span>
        </Text>
        <Input
          color={state?.phoneNumberErr ? "danger" : "primary"}
          fonts="normal"
          placeholder="Enter Here"
          required
          value={state?.phoneNumber}
          type="number"
          min={1}
          onChange={(e) => {
            if (e?.target?.value?.length > 10 || Number(e?.target?.value) < 0) {
              return false;
            } else {
              dispatchState({
                type: "phoneNumber",
                payload: e.target.value,
              });
            }
          }}
        />
        <Text
          type={state?.phoneNumberErr ? "danger" : "normal"}
          fonts="normal"
          fontSize={12}
          className={state?.phoneNumberErr ? "mb0 mt0 float-right" : "d-none"}
        >
          Please Enter 10 digit Phone Number
        </Text>
      </Grid>
      {/* -------Alternate phone number input field------ */}
      <Grid item xs={4}>
        <Text type="normal" fonts="normal" fontSize={16} className="mb mt1">
          <span className="fw500">Alternate Number</span>
        </Text>
        <Input
          color={state?.alternateNumberErr ? "danger" : "primary"}
          fonts="normal"
          placeholder="Enter Here"
          value={state?.alternateNumber}
          min={1}
          type="number"
          onChange={(e) => {
            if (e?.target?.value?.length > 10 || Number(e?.target?.value) < 0) {
              return false;
            } else {
              dispatchState({
                type: "alternateNumber",
                payload: e.target.value,
              });
            }
          }}
        />
        <Text
          type={state?.alternateNumberErr ? "danger" : "normal"}
          fonts="normal"
          fontSize={12}
          className={
            state?.alternateNumberErr ? "mb0 mt0 float-right" : "d-none"
          }
        >
          Please Enter 10 digit Phone Number
        </Text>
      </Grid>
      {/* -------Email input field------ */}
      <Grid item xs={4}>
        <Text type="normal" fonts="normal" fontSize={16} className="mb mt1">
          <span className="fw500">Email Id</span>
        </Text>
        <Input
          color={state?.emailErr ? "danger" : "primary"}
          fonts="normal"
          placeholder="Enter Here"
          value={state?.email}
          maxLength={30}
          type="text"
          onChange={(e) => {
            dispatchState({ type: "email", payload: e.target.value });
          }}
        />
        <Text
          type={state?.emailErr ? "danger" : "normal"}
          fonts="normal"
          fontSize={12}
          className={state?.emailErr ? "mb0 mt0 float-right" : "d-none"}
        >
          Please Enter Valid Email
        </Text>
      </Grid>
      {/* -------PAN input field------ */}
      <Grid item xs={4}>
        <Text type="normal" fonts="normal" fontSize={16} className="mb mt1">
          <span className="fw500">PAN Card Number*</span>
        </Text>
        <Input
          color={state?.panNumberErr ? "danger" : "primary"}
          fonts="normal"
          placeholder="Enter Here"
          required
          value={state?.panNumber}
          type="text"
          className="upperCase"
          minLength={10}
          maxLength={10}
          onChange={(e) => {
            dispatchState({ type: "panNumber", payload: e.target.value });
          }}
        />
        <Text
          type={state?.panNumberErr ? "danger" : "normal"}
          fonts="normal"
          fontSize={12}
          className={state?.panNumberErr ? "mb0 mt0 float-right" : "d-none"}
        >
          Please Enter Valid PAN Card Number
        </Text>
      </Grid>
      {/* -------Adhar input field------ */}
      <Grid item xs={4}>
        <Text type="normal" fonts="normal" fontSize={16} className="mb mt1">
          <span className="fw500">Aadhaar Card Number*</span>
        </Text>
        <Input
          color={state?.aadhaarNumberErr ? "danger" : "primary"}
          fonts="normal"
          placeholder="Enter Here"
          required
          value={state?.aadhaarNumber}
          min={1}
          type="number"
          onChange={(e) => {
            if (e?.target?.value?.length > 12 || Number(e?.target?.value) < 0) {
              return false;
            } else {
              dispatchState({ type: "aadhaarNumber", payload: e.target.value });
            }
          }}
        />
        <Text
          type={state?.aadhaarNumberErr ? "danger" : "normal"}
          fonts="normal"
          fontSize={12}
          className={state?.aadhaarNumberErr ? "mb0 mt0 float-right" : "d-none"}
        >
          Please Enter 12 digit Aadhaar Card Number
        </Text>
      </Grid>
      {/* -------GST Number input field------ */}
      <Grid item xs={4}>
        <Text type="normal" fonts="normal" fontSize={16} className="mb mt1">
          <span className="fw500">GST Number</span>
        </Text>
        <Input
          color={"primary"}
          fonts="normal"
          placeholder="Enter Here"
          maxLength={15}
          value={state?.gstNumber}
          type="text"
          onChange={(e) => {
            dispatchState({ type: "gstNumber", payload: e.target.value });
          }}
        />
      </Grid>

      {/* -------Bank ac number input field------ */}
      <Grid item xs={4}>
        <Text type="normal" fonts="normal" fontSize={16} className="mb mt1">
          <span className="fw500">Bank Account Number*</span>
        </Text>
        <Input
          color={state?.bankAccountNumberErr ? "danger" : "primary"}
          fonts="normal"
          placeholder="Enter Here"
          required
          value={state?.bankAccountNumber}
          type="text"
          maxLength={18}
          minLength={9}
          min={1}
          onChange={(e) => {
            if (e?.target?.value?.length && !/^\d+$/.test(e?.target?.value)) {//e?.target?.value?.length > 14 || Number(e?.target?.value) < 0

              return false;
            }
            else {
              dispatchState({
                type: "bankAccountNumber",
                payload: e.target.value,
              });
            }
          }}
        />
        <Text
          type={state?.bankAccountNumberErr ? "danger" : "normal"}
          fonts="normal"
          fontSize={12}
          className={
            state?.bankAccountNumberErr ? "mb0 mt0 float-right" : "d-none"
          }
        >
          Please Enter Bank Account Number
        </Text>
      </Grid>
      {/* -------Bank input field------ */}
      <Grid item xs={4}>
        <Text type="normal" fonts="normal" fontSize={16} className="mb mt1">
          <span className="fw500">Bank Name*</span>
        </Text>
        <Input
          color={state?.bankNameErr ? "danger" : "primary"}
          fonts="normal"
          placeholder="Enter Here"
          required
          value={state?.bankName}
          type="text"
          maxLength={30}
          onChange={(e) => {
            if (e?.target?.value?.length > 50 || !isNaN(parseInt(e?.target?.value))) {
              return false;
            }
            dispatchState({ type: "bankName", payload: e.target.value });
          }}
        />
        <Text
          type={state?.bankNameErr ? "danger" : "normal"}
          fonts="normal"
          fontSize={12}
          className={state?.bankNameErr ? "mb0 mt0 float-right" : "d-none"}
        >
          Please Enter Bank Name
        </Text>
      </Grid>
      {/* -------Account Owner Name input field------ */}
      <Grid item xs={4}>
        <Text type="normal" fonts="normal" fontSize={16} className="mb mt1">
          <span className="fw500">Account Owner Name*</span>
        </Text>
        <Input
          color={state?.accountOwnerNameErr ? "danger" : "primary"}
          fonts="normal"
          placeholder="Enter Here"
          required
          value={state?.accountOwnerName}
          type="text"
          maxLength={30}
          onChange={(e) => {
            if (!isNaN(parseInt(e.target.value))) {
              return false
            }
            dispatchState({
              type: "accountOwnerName",
              payload: e.target.value,
            });
          }}
        />
        <Text
          type={state?.accountOwnerNameErr ? "danger" : "normal"}
          fonts="normal"
          fontSize={12}
          className={
            state?.accountOwnerNameErr ? "mb0 mt0 float-right" : "d-none"
          }
        >
          Please Enter Account Owner Name
        </Text>
      </Grid>
      {/* -------IFSC input field------ */}
      <Grid item xs={4}>
        <Text type="normal" fonts="normal" fontSize={16} className="mb mt1">
          <span className="fw500">IFSC Code*</span>
        </Text>
        <Input
          color={state?.ifscErr ? "danger" : "primary"}
          fonts="normal"
          placeholder="Enter Here"
          required
          value={state?.IFSC}
          type="text"
          maxLength={11}
          minLength={11}
          onChange={(e) => {
            if (e?.target?.value && !/[A-Z0-9]+/.test(e?.target?.value)) {
              return false;
            }
            dispatchState({
              type: "IFSC",
              payload: e.target.value,
            });
          }}
        />
        <Text
          type={state?.ifscErr ? "danger" : "normal"}
          fonts="normal"
          fontSize={12}
          className={state?.ifscErr ? "mb0 mt0 float-right" : "d-none"}
        >
          Please Enter Valid IFSC Code
        </Text>
      </Grid>
      {/* -------------Image uploades input field------ */}
      <Grid item xs={12} container>
        {/* --------Gst certficate  photo------- */}
        <Grid item xs={4}>
          <ImageInputComponent
            title="GST Certificate Photo"
            setValue={setGSTImg}
            setImageName={setGSTImgName}
            value={GSTImg}
            bind="GSTImg"
            required={false}
            isEdit={editData?.type === "edit" ? true : false}
            imageChanged={false}
          />
        </Grid>
        {/* --------Aadhaar card photo------- */}
        <Grid item xs={4}>
          <ImageInputComponent
            title="Aadhaar Card Photo"
            setValue={setAadhaarImg}
            setImageName={setAadhaarImgName}
            value={aadhaarImg}
            bind="aadhaarImg"
            required={true}
            isEdit={editData?.type === "edit" ? true : false}
            imageChanged={false}
            setErr={setAadhaarImgErr}
          />
          <Text
            type={aadhaarImgErr ? "danger" : "normal"}
            fonts="normal"
            fontSize={12}
            className={aadhaarImgErr ? "mb0 mt0" : "d-none"}
          >
            Please upload Photo
          </Text>
        </Grid>
        {/* --------PAN card photo------- */}
        <Grid item xs={4}>
          <ImageInputComponent
            title="PAN Card Photo"
            setValue={setPanImg}
            setImageName={setPanImgName}
            value={panImg}
            bind="panImg"
            required={true}
            setErr={setPanImgErr}
            isEdit={editData?.type === "edit" ? true : false}
            imageChanged={false}
          />
          <Text
            type={panImgErr ? "danger" : "normal"}
            fonts="normal"
            fontSize={12}
            className={panImgErr ? "mb0 mt0" : "d-none"}
          >
            Please upload Photo
          </Text>
        </Grid>
        {/* --------Cheque passbook photo------- */}
        <Grid item xs={4}>
          <ImageInputComponent
            title="Passbook Photo"
            setValue={setPassbookImg}
            setImageName={setPassbookImgName}
            value={passbookImg}
            bind="passbookImg"
            required={true}
            setErr={setPassbookImgErr}
            isEdit={editData?.type === "edit" ? true : false}
            imageChanged={false}
          />
          <Text
            type={passbookImgErr ? "danger" : "normal"}
            fonts="normal"
            fontSize={12}
            className={passbookImgErr ? "mb0 mt0" : "d-none"}
          >
            Please upload Photo
          </Text>
        </Grid>
      </Grid>

      {/* -------Buttons------ */}
      <Grid item xs={12} container>
        <Grid className="submit_button mt1 mb1">
          <Button
            category="primary"
            icon="delete"
            onClick={handleSubmit}
            type="button"
            isRounded={true}
          >
            {loading ? (
              <Loader color="#fff" loading={loading} size={8} height="auto" />
            ) : (
              "Submit"
            )}
          </Button>
        </Grid>
        <Grid className="cancel_button mt1 mb1 ml-1">
          <Button
            category="border-only"
            icon="delete"
            onClick={handleCancel}
            type="button"
            isRounded={true}
          >
            Cancel
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AddSubContractor;
